"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeCustom = void 0;
var react_1 = __importStar(require("react"));
var title_1 = require("../../title");
require("./index.less");
var swr_1 = __importDefault(require("swr"));
var quote_1 = require("../../../../../modules/quote");
var config_1 = require("../../../../../modules/quote/config");
var addzxgbtn_1 = require("../../zxg/addzxgbtn");
var custom_table_1 = require("../../../../quotetable/custom_table");
var modal_1 = require("../../modal");
var custom_config_1 = require("./custom_config");
var qa_tip_1 = require("../../qa_tip");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var object_hash_1 = __importDefault(require("object-hash"));
var web_1 = require("../../../../../config/web");
/** 默认表格 */
var default_tables = Object.keys(custom_config_1.custom_config.modules).filter(function (v) {
    return custom_config_1.custom_config.modules[v].defaults == true;
});
/**
 * 首页自定义
 * @returns
 */
function HomeCustom() {
    var _a = (0, react_1.useState)(getSaveTableConfig()), selecttables = _a[0], SetSelectTables = _a[1];
    var _b = (0, react_1.useState)(false), showconfig = _b[0], SetShowConfig = _b[1];
    var _c = (0, react_1.useState)(0), tab1_index = _c[0], SetTab1Index = _c[1];
    var modal_reset = function () {
        SetSelectTables((0, cloneDeep_1.default)(default_tables));
    };
    var modal_confirm = function () {
        SaveConfig(selecttables);
        SetShowConfig(false);
    };
    var modal_cancel = function () {
        SetSelectTables(getSaveTableConfig());
        SetShowConfig(false);
    };
    var reset = function () {
        SetSelectTables((0, cloneDeep_1.default)(default_tables));
        SaveConfig((0, cloneDeep_1.default)(default_tables));
    };
    var changeSelect = function (key) {
        SetSelectTables(function (selecttables) {
            var findIndex = selecttables.findIndex(function (v) { return v == key; });
            if (findIndex >= 0) { //如果有则删除
                selecttables = selecttables.slice(0, findIndex).concat(selecttables.slice(findIndex + 1));
            }
            else { //如果没有就加上
                selecttables.push(key);
            }
            return (0, cloneDeep_1.default)(selecttables);
        });
    };
    /** 不感兴趣删除 */
    var delCustomTable = function (key) {
        // changeSelect(key) 
        // SaveConfig(selecttables)
        var findIndex = selecttables.findIndex(function (v) { return v == key; });
        if (findIndex >= 0) { //如果有则删除
            var cur_arr = selecttables.slice(0, findIndex).concat(selecttables.slice(findIndex + 1));
            SaveConfig(cur_arr);
            SetSelectTables(cur_arr);
        }
    };
    return (react_1.default.createElement("div", { className: "homecustom" },
        react_1.default.createElement(CustomItemBoxList, { addtable: function () { SetShowConfig(true); }, delCustomTable: delCustomTable }),
        react_1.default.createElement("div", { className: "hct_config scf" },
            react_1.default.createElement("a", { className: "hct_config_add", href: "#", onClick: function (e) { e.preventDefault(); SetShowConfig(true); } },
                react_1.default.createElement("em", { className: "icon_add" }),
                "\u70B9\u51FB\u6DFB\u52A0\u66F4\u591A\u6A21\u5757",
                react_1.default.createElement(qa_tip_1.TitleHoverTip, { width: 100, top: 25, txt: "\u70B9\u51FB\u6DFB\u52A0\u81EA\u9009\u6A21\u5757", icon: "icon_add_tip" })),
            react_1.default.createElement("a", { className: "hct_config_reset", href: "#", onClick: function (e) { e.preventDefault(); reset(); } },
                react_1.default.createElement("em", { className: "icon_reset" }),
                "\u6062\u590D\u9ED8\u8BA4")),
        showconfig &&
            react_1.default.createElement(modal_1.Modal, { title: "\u6DFB\u52A0\u6A21\u5757", onClose: modal_cancel },
                react_1.default.createElement("div", { className: "cibconfig" },
                    react_1.default.createElement("div", { className: "c_tab1" },
                        react_1.default.createElement("ul", { className: "scf" }, custom_config_1.custom_config.groups.map(function (v, index) {
                            return react_1.default.createElement("li", { key: index, className: index == tab1_index ? 'active' : '', onClick: function () { SetTab1Index(index); } }, v.title);
                        }))),
                    custom_config_1.custom_config.groups[tab1_index].next.map(function (v, index) {
                        return react_1.default.createElement("div", { className: "itemlist", key: index },
                            react_1.default.createElement("div", { className: "itemlist_t" },
                                v.title,
                                ">>"),
                            react_1.default.createElement("div", { className: "itemlist_b scf" },
                                react_1.default.createElement("ul", null, v.next.map(function (v2, index2) {
                                    return react_1.default.createElement("li", { key: index2, className: selecttables.find(function (v3) { return v3 == v2; }) ? 'active' : '', onClick: function () { changeSelect(v2); } }, custom_config_1.custom_config.modules[v2].title);
                                }))));
                    }),
                    react_1.default.createElement("div", { className: "btns" },
                        react_1.default.createElement("div", { className: "confirmbtn", onClick: modal_confirm }, "\u00A0\u786E\u00A0\u5B9A\u00A0"),
                        react_1.default.createElement("div", { className: "resetbtn", onClick: modal_reset }, "\u6062\u590D\u9ED8\u8BA4"))))));
}
exports.HomeCustom = HomeCustom;
/**
 * 表格列表
 */
function CustomItemBoxList(props) {
    //默认列表
    var select_tables = getSaveTableConfig();
    return (react_1.default.createElement("div", { className: "customlist scf" },
        select_tables.map(function (v, index) {
            return react_1.default.createElement(CustomItemBox, { key: index, tablekey: v, delCustomTable: props.delCustomTable });
        }),
        select_tables.length % 4 != 0 &&
            react_1.default.createElement("div", { className: "addcstt", title: "\u6DFB\u52A0\u6A21\u5757", onClick: function () { props.addtable(); } },
                react_1.default.createElement("img", { src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAACSBAMAAABcVY69AAAAJFBMVEUAAADJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnLG5EuAAAAC3RSTlMAgBFebzVLIlh4DAykfBoAAADdSURBVGje7dgxCsJAFIThIYUErR4oaBfsUmtlnTulThk7rSyDJ7DfyynWEpRMMVnnFVt+BLI/yy6KPl4DTFxvFeqgSOsB3QmMuQOXAaQJqEkH7MW+SFVqaFJkLLWif09Ncnfuzt25O13J3bk7d+fuNKXZdpdSerCl8e5IUgBZSw1NioylVnCPK0r/290qfZix7mhSZCy1NAm/Su4uS8nnnc87d/eWfL+Tk2Z7v/O7iqjk7tydu3N3mpK7c3fuzt2pSu7uW+k4UKDlDt2ZIpVb1BEbLGLqWl5R9BSpqJ780fS5J2MctwAAAABJRU5ErkJggg==", alt: "" }))));
}
/**
 * 首页自定义表格
 */
function CustomItemBox(props) {
    var config = custom_config_1.custom_config.modules[props.tablekey]; //表格配置
    var tableitemconfig = custom_table_1.custom_table[config.tabletype]; //表格显示配置
    //行情字段
    var quoteitemlist = tableitemconfig.filter(function (v) {
        return typeof v.value == 'number';
    }).map(function (v) { return v.value; });
    var _a = (0, swr_1.default)("indexcustom_".concat(props.tablekey), function () { return (0, quote_1.searchListQuote)(config.fs, quoteitemlist, config.order, 1, config.count, (config === null || config === void 0 ? void 0 : config.orderdur) == true ? 0 : 1); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _a.data, error = _a.error;
    /** 移除 */
    var removeCustomTable = function (e) {
        e.preventDefault();
        props.delCustomTable && props.delCustomTable(props.tablekey);
    };
    var link = '';
    if (config.link) {
        if (config.link.indexOf('http') == 0 || config.link.indexOf('//') == 0) {
            link = config.link;
        }
        else {
            link = web_1.routerPrefix + config.link;
        }
    }
    return (react_1.default.createElement("div", { className: "customitembox" },
        react_1.default.createElement(title_1.Title1, null,
            react_1.default.createElement(title_1.Title1.Main, null,
                link ?
                    react_1.default.createElement("a", { href: link }, config.title)
                    :
                        react_1.default.createElement("span", null, config.title),
                react_1.default.createElement("span", { className: "del_btn", onClick: removeCustomTable },
                    react_1.default.createElement("em", null)))),
        react_1.default.createElement("div", { className: "cibc" },
            data &&
                react_1.default.createElement("table", { className: "box1quotetable" },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null, tableitemconfig.map(function (v, index) {
                            return react_1.default.createElement("th", { key: index, dangerouslySetInnerHTML: { __html: v.title } });
                        }))),
                    react_1.default.createElement("tbody", null, data.map(function (v, index) {
                        return react_1.default.createElement("tr", { key: index }, tableitemconfig.map(function (v2, index2) {
                            var _a;
                            return react_1.default.createElement("td", { key: index2, className: (_a = v2.tdclass) !== null && _a !== void 0 ? _a : "" },
                                typeof v2.value == 'number' && v[v2.value].html,
                                v2.value == 'addzxg' &&
                                    react_1.default.createElement(addzxgbtn_1.AddZXGBtn, { quotecode: v[config_1.QuoteItem.行情统一链接].source }));
                        }));
                    }))),
            link &&
                react_1.default.createElement("div", { className: "more" },
                    react_1.default.createElement("a", { href: link }, "\u70B9\u51FB\u67E5\u770B\u66F4\u591A>>")))));
}
/**
 * 获取保存的配置信息
 */
function getSaveTableConfig() {
    if (localStorage && localStorage.getItem && localStorage.getItem('customtables') != null) {
        try {
            var savedata = localStorage.getItem('customtables').split(',').filter(function (v) {
                return custom_config_1.custom_config.modules[v] != undefined;
            });
            // if (savedata.length > 0) {
            return savedata;
            // }
        }
        catch (error) {
        }
    }
    return (0, cloneDeep_1.default)(default_tables);
}
/**
 * 保存配置信息
 */
function SaveConfig(tablelist) {
    if (localStorage && localStorage.setItem) {
        try {
            var validarray = tablelist.filter(function (v) {
                return custom_config_1.custom_config.modules[v] != undefined;
            });
            if (validarray.length > 0) {
                //如果和默认的配置一样，则删掉存储
                if ((0, object_hash_1.default)(validarray.sort()) == (0, object_hash_1.default)((0, cloneDeep_1.default)(default_tables).sort())) {
                    localStorage.removeItem('customtables');
                }
                else {
                    //按默认列表排序
                    validarray.sort(function (v1, v2) {
                        var keys = Object.keys(custom_config_1.custom_config.modules);
                        return keys.findIndex(function (v) { return v == v1; }) - keys.findIndex(function (v) { return v == v2; });
                    });
                    localStorage.setItem('customtables', validarray.join(','));
                }
            }
            else if (validarray.length == 0) {
                localStorage.setItem('customtables', '');
            }
            else {
                localStorage.removeItem('customtables');
            }
        }
        catch (error) {
        }
    }
}
